import { useMutation } from '@tanstack/react-query';
import { queryContext } from "../context/fractal-sdk-context.js";
import { authPrivateWebSdkApiClient } from "../core/api/client.js";
import { ApiFeature } from "../core/api/types.js";
import { FractalSDKAuthenticationUnknownError } from "../core/error/index.js";
import { Scope } from "../types/index.js";
const DEFAULT_SCOPE = [Scope.IDENTIFY];
var AuthApiKey;
(function (AuthApiKey) {
    AuthApiKey["GET_APPROVAL_URL"] = "GET_APPROVAL_URL";
})(AuthApiKey || (AuthApiKey = {}));
export const AuthApiKeys = {
    getAuthUrl: (clientId, scopes) => [ApiFeature.COINS, AuthApiKey.GET_APPROVAL_URL, clientId, scopes],
};
export const useGetAuthUrlMutation = (clientId, scopes = DEFAULT_SCOPE) => {
    return useMutation(AuthApiKeys.getAuthUrl(clientId, scopes), async () => AuthApi.getAuthUrl(clientId, scopes), {
        context: queryContext,
    });
};
const AuthApi = {
    getAuthUrl,
};
async function getAuthUrl(clientId, scopes) {
    const response = await authPrivateWebSdkApiClient.privateWebSdk.getApprovalUrl({
        clientId,
        scope: scopes,
    });
    if (response.error) {
        throw new FractalSDKAuthenticationUnknownError(`There was an issue generating the approval url. error = ${response.error.message}`);
    }
    return response.data;
}
//# sourceMappingURL=auth.js.map